import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { getGDSearchlist } from "../Actions/GDLibraryAPI";

const searchData = {
  companyname: '', pagenumber: 1, pagesize: 10
}

export const postGDData = (postItem) => {
  let url = `${API.GDPostAPI}`;
  return dispatch => {
    axios.post(url, postItem)
      .then((response) => {
        if (response.data) {
          toast.success('Added Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch(getGDSearchlist(searchData));
        }
        dispatch({
          type: "GDPostSuccessfull",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GDPostSuccessFailure",
          error: "ERROR"
        })
      })
  }
}
export const updateGDData = (postItem) => {
  let url = `${API.GDPostAPI}`;
  return dispatch => {
    axios.put(url, postItem)
      .then((response) => {
        // dispatch({type:'GDUpdate',data:true})
        dispatch({
          type: "GDupdateSuccess",
          data: response.data,
        })
        toast.success('GD Data Updated Successfully', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch(getGDSearchlist(searchData));
      })
      .catch((error) => {
        dispatch({
          type: "GDupdateFailure",
          error: "ERROR"
        })
      })
  }
}
export const postGDAttachment = (postItem) => {
  const data = new FormData()
  data.append('file', postItem)
  let url = `${API.AttachmentAPI}`;
  return dispatch => {
    axios.post(url, data)
      .then((response) => {
        console.log(response.data)
        dispatch({

          type: "GDAttchmentUploadSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GDAttchmentUploadFailure",
          error: "ERROR"
        })
      })
  }
}
